import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupIntersect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBooleanGroupIntersect"><Path fillRule="evenodd" clipRule="evenodd" d="M8 2H22V16H16V22H2V8H8V2ZM20 14H16V8H10V4H20V14ZM8 10H4V20H14V16H8V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupIntersect;
